var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loading-wrapper"},on:{"click":_vm.notBusyAnymore}},[_c('div',{staticClass:"loader"},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.busyMessage)}}),_c('span'),_c('span'),_c('span')])])}
var staticRenderFns = []

export { render, staticRenderFns }